<template>
  <v-container fluid>
    <alert-error :error="error"></alert-error>
    <v-toolbar>
      <v-toolbar-title>{{ $t('NAVIGATION.EXPENSES') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="amountCreate()">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('EREPORTER.EXPENSES.ITEM') }}
        {{ $t('EREPORTER.EXPENSES.REPORT') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <expenses-list-filter
        @setRequest="setRequest"
        @setExportOptions="setExportOptions"
      />
      <expenses-list
        v-model="selected"
        :expenses="expenses"
        :options="options"
        :export-options="exportOptions"
        :meta="meta"
        @show="show"
        @refresh="getDataExpenses"
      ></expenses-list>

      <v-dialog v-if="dialog" v-model="dialog" persistent max-width="600px">
        <amount-report-form
          :amount="amount"
          :errors="errors.getAll()"
          @isValid="isValid"
          @setAmount="setAmount"
          @update-prop="clearErrorByName($event)"
        >
          <template v-slot:header>
            <span class="text-h5"
              >{{ $t('ITEM.CREATE') }} {{ $t('EREPORTER.EXPENSES.ITEM') }}
              {{ $t('EREPORTER.EXPENSES.REPORT') }}
            </span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <template v-slot:buttons>
            <v-btn outlined depressed color="grey" @click="closeDialog">
              {{ $t('BUTTON.CANCEL') }}
            </v-btn>

            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              depressed
              :disabled="!valid"
              @click="saveAmount"
            >
              {{ $t('BUTTON.SAVE') }}
            </v-btn>
          </template>
        </amount-report-form>
      </v-dialog>
    </v-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ExpensesListFilter from '../../components/forms/Expenses/ExpensesListFilter';
import ExpensesList from '@/modules/ereporter/components/Expenses/ExpensesList';
import errors from '@/modules/_global/mixins/errors';

export default {
  name: 'ExpensesPage',

  components: {
    ExpensesList,
    ExpensesListFilter,
    AlertError: () => import('@/modules/_global/_components/AlertError'),

    AmountReportForm: () =>
      import('@/modules/ereporter/components/forms/Expenses/AmountReportForm')
  },

  mixins: [errors],

  data() {
    return {
      error: null,
      meta: {},
      options: {},
      exportOptions: {},
      amount: null,
      dialog: false,
      valid: true,
      editedAmount: null,
      selected: []
    };
  },

  computed: {
    ...mapState('ereporter', ['expenses']),
    prevParams() {
      return this.$store.getters['ereporter/EXPENSES_FILTER'];
    }
  },

  methods: {
    ...mapActions('ereporter', ['getExpenses', 'createAmountReport']),
    getDataExpenses(params) {
      this.getExpenses(params)
        .then(({ data }) => {
          this.meta = data.meta;
        })
        .catch(error => {
          this.error = error;
          console.log(error);
        });
    },
    setRequest(v) {
      this.selected = [];
      this.options = v;
    },
    setExportOptions(v) {
      this.exportOptions = v;
    },
    show(item) {
      this.$router.push({
        name: 'ereporter.amount.show',
        params: { id: item.id }
      });
    },
    closeDialog() {
      (this.amount = null),
        (this.dialog = false),
        this.errors.clear('kilometers'),
        this.errors.clear('expenses');
    },
    isValid(val) {
      this.valid = val;
    },
    amountCreate() {
      this.amount = null;
      this.dialog = true;
      this.valid = false;
    },
    setAmount(val) {
      this.editedAmount = val;
    },
    saveAmount() {
      this.createAmountReport({ amount: this.editedAmount })
        .then(() => {
          this.closeDialog();
          this.getDataExpenses({ params: this.prevParams });
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
